import { render, staticRenderFns } from "./solicitacoes-setores.vue?vue&type=template&id=f5d4066e&"
import script from "./solicitacoes-setores.vue?vue&type=script&lang=js&"
export * from "./solicitacoes-setores.vue?vue&type=script&lang=js&"
import style0 from "./solicitacoes-setores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports